import React from "react";
import {Route, Switch} from "react-router-dom";

import RegionList from "../../containers/yotta/settings/region/RegionList";
import NewRegion from "../../containers/yotta/settings/region/NewRegion";
import DistrictList from "../../containers/yotta/settings/district/DistrictList";
import NewDistrict from "../../containers/yotta/settings/district/NewDistrict";
import LocalList from "../../containers/yotta/settings/local/LocalList";
import NewLocal from "../../containers/yotta/settings/local/NewLocal";
import OfficeList from "../../containers/yotta/settings/office/OfficeList";
import NewOffice from "../../containers/yotta/settings/office/NewOffice";
import FundProgramList from "../../containers/yotta/settings/fund_program/FundProgramList";
import NewFundProgram from "../../containers/yotta/settings/fund_program/NewFundProgram";
import FunctionalExpenseList from "../../containers/yotta/settings/functional_expense/FunctionalExpenseList";
import NewFunctionalExpense from "../../containers/yotta/settings/functional_expense/NewFunctionalExpense";
import ApproverList from "../../containers/yotta/settings/approver/ApproverList";
import NewApprover from "../../containers/yotta/settings/approver/NewApprover";
import BankAccountList from "../../containers/yotta/settings/bank_account/BankAccountList";
import NewBankAccount from "../../containers/yotta/settings/bank_account/NewBankAccount";

const CRM = ({match}) => (
    <Switch>
        <Route path={`${match.url}/regions`} component={RegionList}/>
        <Route path={`${match.url}/newregion`} component={NewRegion}/>
        <Route path={`${match.url}/regionedit/:id`} component={NewRegion}/>
        <Route path={`${match.url}/district`} component={DistrictList}/>
        <Route path={`${match.url}/newdistrict`} component={NewDistrict}/>
        <Route path={`${match.url}/districtedit/:id`} component={NewDistrict}/>
        <Route path={`${match.url}/local`} component={LocalList}/>
        <Route path={`${match.url}/newlocal`} component={NewLocal}/>
        <Route path={`${match.url}/localedit/:id`} component={NewLocal}/>
        <Route path={`${match.url}/offices`} component={OfficeList}/>
        <Route path={`${match.url}/newoffice`} component={NewOffice}/>
        <Route path={`${match.url}/officeedit/:id`} component={NewOffice}/>
        <Route path={`${match.url}/fundprograms`} component={FundProgramList}/>
        <Route path={`${match.url}/newfundprogram`} component={NewFundProgram}/>
        <Route path={`${match.url}/fundprogramedit/:id`} component={NewFundProgram}/>
        <Route path={`${match.url}/functionalexpenses`} component={FunctionalExpenseList}/>
        <Route path={`${match.url}/newfunctionalexpense`} component={NewFunctionalExpense}/>
        <Route path={`${match.url}/functionalexpenseedit/:id`} component={NewFunctionalExpense}/>
        <Route path={`${match.url}/approvers`} component={ApproverList}/>
        <Route path={`${match.url}/newapprover`} component={NewApprover}/>
        <Route path={`${match.url}/approveredit/:id`} component={NewApprover}/>
        <Route path={`${match.url}/bankaccounts`} component={BankAccountList}/>
        <Route path={`${match.url}/newbankaccount`} component={NewBankAccount}/>
        <Route path={`${match.url}/bankaccountedit/:id`} component={NewBankAccount}/>
    </Switch>
);

export default CRM;
